import service from "../api/services/resultService";

export default {
    namespaced: true,
    state: {

    },    
    actions: {
        getTestResultsList(context, reqData) {
            return service.getTestResultsList(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getChapterWiseInfo(context, reqData) {
            return service.getChapterWiseInfo(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getTopicWiseInfo(context, reqData) {
            return service.getTopicWiseInfo(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getBatchWiseHealth(context, reqData) {
            return service.getBatchWiseHealth(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getAllBatchWiseHealth(context, reqData) {
            return service.getAllBatchWiseHealth(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getSubjectHealthStudentWise(context, reqData) {
            return service.getSubjectHealthStudentWise(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getScoreData(context, reqData) {
            return service.getScoreData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getScoreBySubjectId(context, reqData) {
            return service.getScoreBySubjectId(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getDataForChapterWisePerformance(context, reqData) {
            return service.getDataForChapterWisePerformance(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getTestSubjects(context, reqData) {
            return service.getTestSubjects(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getTimeMachineList(context, reqData) {
            return service.getTimeMachineList(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getDetailsOfAttempList(context, reqData) {
            return service.getDetailsOfAttempList(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getTestWiseAnalysisList(context, reqData) {
            return service.getTestWiseAnalysisList(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getPercentileData(context, reqData) {
            return service.getPercentileData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        objectQuestion(context, reqData) {
            return service.objectQuestion(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getMyHealthData(context, reqData) {
            return service.getMyHealthData(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getSubjectsList(context, reqData) {
            return service.getSubjectsList(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getSubjectBatchWise(context, reqData) {
            return service.getSubjectBatchWise(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getQuestionDetails(context, reqData) {
            return service.getQuestionDetails(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getStudentSubjectTree(context, reqData) {
            return service.getStudentSubjectTree(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        getChildren(context, reqData) {
            return service.getChildren(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
        checkResultCalculated(context, reqData) {
            return service.checkResultCalculated(reqData).then((response = {}) => {
                return response.responseData;
            });
        },
    }
};